export class UpdateProfileLocaleRequestDto {
    constructor(public locale: string) {
    }
}
